<div class="flat-rate-item-dialog">
  <div class="ui-g p-0">
    <!-- Start flat rate Header -->
    <div class="ui-g-12 dialog-header flex-start-center pb-0">
      <div class="flat-rate-header flex-between-center width-100p" [ngClass]="{ 'pb-2': this.flatRate?.title }">
        <div class="width-100p flex-start-center">
          <div class="width-45 flex-center-center font-16">
            <i class="fal fa-money-check header-icon"></i>
          </div>

          <div class="flat-rate-title-group">
            <app-input name="flatRateTitle" *ngIf="!companyLocalization" placeholder="Enter flat rate item name"
              maxlength="50" styleClassError="flat-rate-error" styleClassInput="flat-rate" [autoFocus]="focus?.title"
              [theme]="!flatRateErrors?.title || focus?.title ? 'secondary' : 'light'" [value]="flatRate?.title"
              [isInvalid]="flatRateErrors?.title" [errorMessage]="flatRateErrors?.title"
              (appChange)="handleChange('title', $event)" (appFocus)="handleFocus('title')"
              (appBlur)="handleBlur('title')">
            </app-input>
            <p class="fee-heading" *ngIf="companyLocalization">Flat Rate Details</p>
          </div>
        </div>

        <div class="p-1" [hidden]="isLoading">
          <app-switch-pill position="end" [fontSize]="12" [isActive]="flatRate.status"
            [label]="flatRate.status ? 'Active' : 'Inactive'" (appChange)="handleChange('status', $event)">
          </app-switch-pill>
        </div>

        <i class="dialog-close fa-times fal font-18 ml-3 mr-3" (click)="handleClose()"></i>
      </div>
    </div>
    <!-- End flat rate Header -->

    <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" (onChange)="selectedTab = $event">
      <p-tabPanel [selected]="selectedTab === 0">
        <ng-template pTemplate="header"> Basic info </ng-template>

        <ng-template pTemplate="content">
          <!-- Start flat rate Body -->
          <div class="dialog-body width-100p">
            <div class="dialog-total flex-start-center" *ngIf="!companyLocalization else localizationDesc">
              <!-- Description -->
              <div class="flat-rate-description mr-2">
                <app-input name="Desc" placeholder="Description" type="text" maxlength="50" theme="primary"
                  [isInvalid]="flatRateErrors?.description" [value]="flatRate?.description"
                  [autoFocus]="focus?.description" [floatingLabel]="true" [fontSize]="14"
                  (appChange)="handleChange('description', $event)" (appFocus)="handleFocus('description')"
                  (appBlur)="handleBlur('description')">
                </app-input>
              </div>

              <!-- Total Cost -->
              <div class="flat-rate-cost mr-2 position-relative not-allowed">
                <div class="disabled"></div>
                <app-input name="total-cost" placeholder="$0.00" theme="primary" label="Total Cost"
                  styleClassLabel="pl-0 abs-left-0" styleClass="pl-0" [floatingLabel]="true"
                  [value]="flatRate?.itemTotal?.totalCost | currency : usd" [disabled]="true" [fontSize]="14">
                </app-input>
              </div>

              <!-- Total Amount -->
              <div class="flat-rate-amount mr-2 position-relative not-allowed">
                <div class="disabled"></div>
                <app-input name="total-amount" placeholder="$0.00" theme="primary" label="Total Amount"
                  styleClassLabel="pl-0 abs-left-0" styleClass="pl-0"
                  [value]="flatRate?.itemTotal?.totalAmount | currency : usd" [disabled]="true" [floatingLabel]="true"
                  [fontSize]="14">
                </app-input>
              </div>

              <!-- Total Flat rate -->
              <div class="flat-rate-rate mr-2">
                <app-input name="flat-rate" placeholder="$0.00" [selectTextOnFocus]="true"
                  [allowDecimal]="focus?.flatRate" theme="primary" [isInvalid]="flatRateErrors?.flatRate"
                  label="Flat rate" [errorMessage]="flatRateErrors?.flatRate"
                  [value]="focus?.flatRate ? flatRate?.flatRate : (flatRate?.flatRate | currency : usd)"
                  [floatingLabel]="true" [fontSize]="14" (appChange)="handleChange('flatRate', $event)"
                  (appFocus)="handleFocus('flatRate')" (appBlur)="handleBlur('flatRate')">
                </app-input>
              </div>

              <div class="flat-rate-icon">
                <i class="far fa-sack-dollar font-gray-65" tooltipPosition="bottom"
                  tooltipStyleClass="flat-rate tooltip-width-500" [pTooltip]="flatRate?.tooltip" [escape]="false"></i>
              </div>
            </div>
            <ng-template #localizationDesc>
              <div class="dialog-total flex-start-center mb-4 d-flex width-100p"
                [ngClass]="{'flex-row-reverse': currentLang === 'fr'}">
                <!-- Title -->
                <div class="flat-rate-description d-flex align-items-center">
                  <div class="icon flex-center-start">
                    <i class="fal fa-money-check"></i>
                  </div>
                  <div class="width-95p pl-1 pr-1">
                    <app-input name="title" placeholder="Flat rate item name (EN){{ currentLang === 'en'? '*' : '' }}"
                      type="text" maxlength="50" theme="primary" [isInvalid]="flatRateErrors?.title"
                      styleClassInput="w-100" [value]="flatRate?.title" [autoFocus]="focus?.title"
                      [errorMessage]="flatRateErrors?.title" [floatingLabel]="true" [fontSize]="14"
                      (appChange)="handleChange('title', $event)" (appFocus)="handleFocus('title')"
                      (appBlur)="handleBlur('title')">
                    </app-input>
                  </div>
                </div>
                <div class="flat-rate-description d-flex align-items-center">
                  <div class="icon flex-center-start">
                    <i class="fal fa-money-check"></i>
                  </div>
                  <div class="width-95p pl-1 pr-1">
                    <app-input name="titleFR" placeholder="Flat rate item name (FR){{ currentLang === 'fr'? '*' : '' }}"
                      type="text" maxlength="50" theme="primary" [isInvalid]="flatRateErrors?.titleFR"
                      [errorMessage]="flatRateErrors?.titleFR" styleClassInput="w-100" [value]="flatRate?.titleFR"
                      [autoFocus]="focus?.titleFR" [floatingLabel]="true" [fontSize]="14"
                      (appChange)="handleChange('titleFR', $event)" (appFocus)="handleFocus('titleFR')"
                      (appBlur)="handleBlur('titleFR')">
                    </app-input>
                  </div>
                </div>

              </div>
              <div class="dialog-total flex-start-center d-flex" [ngClass]="{'flex-row-reverse': currentLang === 'fr'}">
                <!-- Description -->
                <div class="flat-rate-description mr-2">
                  <app-input name="Desc" placeholder="Description (EN)" type="text" maxlength="50" theme="primary"
                    [isInvalid]="flatRateErrors?.description" [value]="flatRate?.description"
                    [autoFocus]="focus?.description" [floatingLabel]="true" [fontSize]="14"
                    (appChange)="handleChange('description', $event)" (appFocus)="handleFocus('description')"
                    (appBlur)="handleBlur('description')">
                  </app-input>
                </div>
                <div class="flat-rate-description mr-2">
                  <app-input name="DescFR" placeholder="Description (FR)" type="text" maxlength="50" theme="primary"
                    [isInvalid]="flatRateErrors?.descriptionFR" [value]="flatRate?.descriptionFR"
                    [autoFocus]="focus?.descriptionFR" [floatingLabel]="true" [fontSize]="14"
                    (appChange)="handleChange('descriptionFR', $event)" (appFocus)="handleFocus('descriptionFR')"
                    (appBlur)="handleBlur('descriptionFR')">
                  </app-input>
                </div>

              </div>
            </ng-template>

            <div class="dialog-switch-pill flex-start-center mt-4 mb-25">
              <app-switch-pill id="item-display-desc" label="Display desc. on estimate & invoice" position="end"
                styleClassLabel="font-gray-35" [isActive]="flatRate?.displayDescOnOrder" [fontSize]="12"
                (appChange)="handleChange('displayDescOnOrder', $event)">
              </app-switch-pill>

              <app-switch-pill id="item-display-qty" label="Display qty. on estimate & invoice" position="end"
                styleClassLabel="font-gray-35" [isActive]="flatRate?.displayHoursOnOrder" [fontSize]="12"
                (appChange)="handleChange('displayHoursOnOrder', $event)">
              </app-switch-pill>
            </div>

            <div class="dialog-total flex-start-center" *ngIf="companyLocalization">
              <!-- Total Flat rate -->
              <div class="mr-2 ui-g-6">
                <app-input name="flat-rate" placeholder="$0.00" [selectTextOnFocus]="true"
                  [allowDecimal]="focus?.flatRate" theme="primary" [isInvalid]="flatRateErrors?.flatRate"
                  label="Flat rate"
                  [value]="focus?.flatRate ? flatRate?.flatRate : (flatRate?.flatRate | currency : usd)"
                  [floatingLabel]="true" [fontSize]="14" (appChange)="handleChange('flatRate', $event)"
                  (appFocus)="handleFocus('flatRate')" (appBlur)="handleBlur('flatRate')">
                </app-input>
              </div>

              <div class="flat-rate-icon">
                <i class="far fa-sack-dollar font-gray-65" tooltipPosition="bottom"
                  tooltipStyleClass="flat-rate tooltip-width-500" [pTooltip]="flatRate?.tooltip" [escape]="false"></i>
              </div>


              <!-- Total Cost -->
              <div class="flat-rate-cost mr-2 position-relative not-allowed">
                <div class="disabled"></div>
                <app-input name="total-cost" placeholder="$0.00" theme="primary" label="Total Cost"
                  styleClassLabel="pl-0 abs-left-0" styleClass="pl-0" [floatingLabel]="true"
                  [value]="flatRate?.itemTotal?.totalCost | currency : usd" [disabled]="true" [fontSize]="14">
                </app-input>
              </div>

              <!-- Total Amount -->
              <div class="flat-rate-amount mr-2 position-relative not-allowed">
                <div class="disabled"></div>
                <app-input name="total-amount" placeholder="$0.00" theme="primary" label="Total Amount"
                  styleClassLabel="pl-0 abs-left-0" styleClass="pl-0"
                  [value]="flatRate?.itemTotal?.totalAmount | currency : usd" [disabled]="true" [floatingLabel]="true"
                  [fontSize]="14">
                </app-input>
              </div>
            </div>

            <div class="ui-g-12">
              <p class="mb-0 font-600">Individual items</p>
            </div>

            <div class="ui-g-12 p-0">
              <div class="table table-individual">
                <div class="table-header flex-start-center">
                  <div class="table-heading type font-600">Type</div>

                  <div class="table-heading partService font-600">Part/Service</div>

                  <div class="table-heading description font-600">Description</div>

                  <div class="table-heading unitcost font-600">Unit&nbsp;Cost</div>

                  <div class="table-heading unitprice font-600">Unit&nbsp;Price</div>

                  <div class="table-heading quantity font-600">Qty</div>

                  <div class="table-heading cost font-600">Cost</div>

                  <div class="table-heading netamount font-600">Amount</div>

                  <div class="table-heading flatrate font-600">Net&nbsp;Amount</div>

                  <!-- <div class="table-heading taxable font-600 pl-8p">
              Taxable
            </div> -->

                  <div class="table-heading icons"></div>
                </div>

                <div class="table-body flex-start-center" *ngIf="!isLoadingSuppliers && flatRate?.subItems?.length">
                  <app-flat-rate-sub-item *ngFor="let subItem of flatRate?.subItems; let itemIndex = index"
                    [errors]="errors[itemIndex] || {}" [itemIndex]="itemIndex" [subItem]="subItem"
                    [isQuickServiceEnabled]="isQuickServiceEnabled" [partsLookupDropDownList]="partsLookupDropDownList"
                    [isCommissionPlanEnabled]="isCommissionPlanEnabled" [companyLocalization]="companyLocalization"
                    [currentLang]="currentLang" [isLast]="flatRate?.subItems?.length - 1 === itemIndex"
                    [defaultSupplierList]="defaultSuppliers" (appFetchSupplier)="getSupplierList()"
                    (appCalculateFlatRateTotal)="handleCalculateFlatRateTotal()" (appHandleAdd)="handleSubItemAdd()"
                    (appHandleDelete)="handleSubItemDelete(itemIndex)">
                  </app-flat-rate-sub-item>
                </div>
              </div>
            </div>
          </div>
          <!-- End flat rate Body -->

          <!-- Start flat rate Footer -->
          <div class="ui-g-12 dialog-footer flat-rate-footer">
            <div class="ui-g-6">
              <app-checkbox *ngIf="!bundleId" inputId="flatRate-checkbox" label="Add another" [fontSize]="12"
                [isChecked]="isCreateAnother" (appChange)="isCreateAnother = $event"> </app-checkbox>

              <span *ngIf="(orderServiceId || isOpenFromPO) && bundleId" class="width-100p"
                [ngClass]="{ invisible: !isOpenFromPO && (isLocal || !orderServiceId) }">
                <app-checkbox inputId="cb-flat-rate-add-another" label="Also update flat rate across application"
                  [isChecked]="updateGenericItem" (appChange)="updateGenericItem = $event">
                </app-checkbox>
              </span>
            </div>

            <div class="ui-g-6 text-right">
              <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>

              <button class="btn btn-primary btn-submit"
                [disabled]="!flatRate?.subItems?.length || isProcessing || (!bundleId && currentLang === 'en' && isCheckingUniqueness) || !isTitleUnique || isFinalizedRo || isLockedRO"
                tooltipPosition="top"
                [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
                (click)="onSubmit()">
                <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
                <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
              </button>
            </div>
          </div>
          <!-- Start flat rate Footer -->
        </ng-template>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === 1">
        <ng-template pTemplate="header"> Activity logs </ng-template>
        <ng-template pTemplate="content">
          <div class="activity-logs">
            <div class="catalog-activity-wrapper">
              <!-- Activity logs -->
              <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
                <div *ngFor="let activityLog of activityLogs">
                  <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
                </div>
              </div>

              <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
                <p>There is no activity logs.</p>
              </div>
            </div>
          </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>